"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Divider = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  background: var(--snow-darker);\n  ", ";\n"], ["\n  width: 100%;\n  height: ", ";\n  background: var(--snow-darker);\n  ", ";\n"])), function (props) { return "".concat(props.thickness || 1, "px"); }, function (props) { return (props.noMargins ? "margin: 0;" : "margin: 2rem 0;"); });
var templateObject_1;
